/**
 * Created by RUSS_ on 01.05.2018
 */
import { mainChannel, userChannel } from "./message-hub";
import { URL_TO_COOKIE_PRIVACY } from "../const/constants";

export default class MyLocaleManager {
  constructor(browserData) {
    window.browserData = browserData;
    //append to global scope
    window.myTranslation = this.translate;
  }

  translate(key) {
    const DIC = {
      en: {
        short_cookie_description: `We use cookies on this website to analyze traffic, save your preferences, social media features, and to enhance your experience.`,
        long_intro_cookie_description: `Cookies are important for the correct functioning of a website. To give you a more enjoyable experience, we use cookies to store your credentials to ensure secure login, to collect statistical data to optimize website functionality, to provide you with content tailored to your interests, and for ads personalisation. Click "Agree and continue" to accept cookies and navigate directly to the site; or click "Set Cookie Preferences" below for a detailed description of the types of cookies we use and to decide whether to save certain cookies when using our website.`,
        overview_please_allow: `Configure below which cookies you agree to being used and stored on this website:`,
        accept: "Accept",
        title_cookie_settings: "Your cookie settings for this website",
        basic_settings: "Basic settings",
        accept_selected_cookies: "Accept Selected",
        accept_and_continue: "Accept and continue",
        set_cookie_preferences: "Set Cookie Preferences",
        advanced_settings: "Advanced Settings",
        necessary: "Necessary",
        necessary_desc:
          "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
        preferences: "Preferences",
        preferences_desc:
          "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.",
        statistics: "Statistics",
        statistics_desc:
          "Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.",
        marketing: "Marketing",
        marketing_desc:
          "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
        cancel: "Cancel",
        show_cookies: "Show Cookies",
        hide_cookies: "Hide Cookies",
        company: "Company",
        domains: "Domains",
        cookie_preferences: "Cookie Preferences",
        to_see_this_activate: "You can see this area if you accept cookie",
        accept_all_and_continue: "Accept all and continue",
        accept_minimal_and_continue: "Accept minimal and continue",
        please_accept_cookie: "Please accept usage of following cookie: ",
        purpose_of_the_usage: "Purpose of use",
        more_info: "More info"
      },
      de: {
        short_cookie_description: `Wir setzen Cookies auf dieser Website ein, um Zugriffe darauf zu analysieren, Ihre bevorzugten Einstellungen zu speichern, Funktionen für soziale Medien anbieten zu können und Ihre Nutzererfahrung zu optimieren.`,
        long_intro_cookie_description: `Cookies sind für die korrekte Funktionsweise einer Website wichtig. Um Ihnen ein angenehmeres Erlebnis zu bieten, verwenden wir Cookies, um Ihre Anmeldeinformationen zu speichern, um eine sichere Anmeldung zu gewährleisten, um statistische Daten zur Optimierung der Website-Funktionalität zu sammeln, um Ihnen auf Ihre Interessen zugeschnittene Inhalte bereitzustellen und um Anzeigen zu personalisieren. Klicken Sie auf „Zustimmen und fortfahren“, um Cookies zu akzeptieren und direkt zur Website weiter zu navigieren; oder klicken Sie unten auf „Cookie-Einstellungen festlegen“, um eine detaillierte Beschreibung der von uns verwendeten Arten von Cookies zu erhalten und um zu entscheiden, ob bestimmte Cookies bei der Nutzung unserer Website gespeichert werden sollen.`,
        overview_please_allow: `Konfigurieren Sie unten, welche Cookies von dieser Website verwendet und gespeichert werden können:`,
        accept: "Akzeptieren",
        title_cookie_settings: "Ihre Cookie-Einstellungen für diese Website",
        basic_settings: "Grundeinstellungen",
        accept_selected_cookies: "Ausgewählte Akzeptieren",
        accept_and_continue: "Zustimmen und fortfahren",
        set_cookie_preferences: "Cookie-Einstellungen festlegen",
        advanced_settings: "Erweiterte Einstellungen",
        necessary: "Notwendige",
        necessary_desc:
          "Notwendige Cookies helfen dabei, eine Website nutzbar zu machen, indem grundlegende Funktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Website aktiviert werden. Die Website kann ohne diese Cookies nicht ordnungsgemäß funktionieren.",
        preferences: "Einstellungen",
        preferences_desc:
          "Präferenz-Cookies ermöglichen einer Website, sich an Informationen zu erinnern, die die Art und Weise, wie sich die Website verhält, verändern, z. B. Ihre bevorzugte Sprache oder die Region, in der Sie sich befinden.",
        statistics: "Statistiken",
        statistics_desc:
          "Statistische Cookies helfen Website-Betreibern zu verstehen, wie Besucher mit Websites interagieren, indem sie Informationen anonym sammeln und melden.",
        marketing: "Marketing",
        marketing_desc:
          "Marketing-Cookies werden verwendet, um Besucher über Websites zu verfolgen. Die Absicht ist, Anzeigen zu schalten, die für den einzelnen Nutzer relevant und einnehmend sind und somit für Publisher und Drittanbieter-Werbetreibende wertvoller sind.",
        cancel: "Abbrechen",
        show_cookies: "Cookies Anzeigen",
        hide_cookies: "Cookies Ausblenden",
        company: "Unternehmen",
        domains: "Domänen",
        cookie_preferences: "Cookie-Einstellungen",
        to_see_this_activate:
          "Sie können diesen Bereich sehen, wenn Sie folgende Cookie akzeptieren",
        accept_all_and_continue: "Alle Akzeptieren und fortfahren",
        accept_minimal_and_continue: "Minimale Akzeptieren und fortfahren",
        please_accept_cookie:
          "Bitte akzeptieren Sie die Verwendung des folgenden Cookies: ",
        purpose_of_the_usage: "Zweck der Verwendung",
        more_info: "Details"
      },
      ru: {
        short_cookie_description: `Мы используем cookies, чтобы проводить аналитику посещений, предоставлять функции социальных сетей и улучшать качество нашего сервиса.`,
        long_intro_cookie_description: `Файлы Cookie важны для правильного функционирования веб-сайта. Мы используем файлы cookie для хранения ваших учетных данных для обеспечения безопасного входа в систему, Чтобы предоставить вам более приятный опыт, мы используем файлы cookie для хранения ваших учетных данных, чтобы обеспечить безопасный вход в систему, для сбора статистических данных для оптимизации функциональности веб-сайта, для предоставления вам контента, адаптированного к вашим интересам, и для персонализации рекламы. Нажмите «Принять и продолжить», чтобы принять файлы Cookie и продолжить навигацию непосредственно на сайт; или нажмите «Настроить cookie» ниже, чтобы получить подробное описание типов файлов cookie, которые мы используем, и решить, следует ли хранить некоторые файлы cookie при использовании нашего веб-сайта.`,
        overview_please_allow: `Настройте ниже, какие файлы cookie вы соглашаетесь использовать и хранить с этого веб-сайта:`,
        accept: "Согласен",
        title_cookie_settings: "Настройки cookie для этого веб-сайта",
        basic_settings: "Базовые настройки",
        accept_selected_cookies: "Принять выбранные",
        accept_and_continue: "Принять и продолжить",
        set_cookie_preferences: "Настроить cookie",
        advanced_settings: "Расширенные настройки",
        necessary: "Необходимые",
        necessary_desc:
          "Необходимые файлы cookie помогают сделать сайт пригодным для использования, включив основные функции, такие как навигация по страницам и доступ к защищенным областям веб-сайта. Веб-сайт не может функционировать должным образом без этих файлов cookie.",
        preferences: "Предпочтения",
        preferences_desc:
          "Файлы Cookie для предпочтений позволяет веб-сайту запоминать информацию, которая изменяет поведение или внешний вид веб-сайта, например, ваш предпочтительный язык или регион, в котором вы находитесь.",
        statistics: "Статистика",
        statistics_desc:
          "Статистические файлы cookie помогают владельцам веб-сайтов понять, как посетители взаимодействуют с веб-сайтами, собирая и сообщая информацию анонимно.",
        marketing: "Маркетинг",
        marketing_desc:
          "Маркетинговые Cookie используются для отслеживания посетителей через веб-сайты. Цель состоит в том, чтобы показывать рекламу, которая является релевантной и привлекательной для отдельного пользователя, и тем самым более ценна для издателей и сторонних рекламодателей.",
        cancel: "Отменить",
        show_cookies: "Показать Cookies",
        hide_cookies: "Скрыть Cookies",
        company: "Компания",
        domains: "Доменные имена",
        cookie_preferences: "Настройки Cookie",
        to_see_this_activate:
          "Вы сможете видеть эту область если активируете Cookie",
        accept_all_and_continue: "Принять все и продолжить",
        accept_minimal_and_continue: "Принять минимальные и продолжить",
        please_accept_cookie:
          "Пожалуйста, примите использование следующих файлов Cookie: ",
        purpose_of_the_usage: "Цель использования",
        more_info: "Подробнее"
      }
    };
    if (
      browserData.language &&
      DIC[browserData.language.toLowerCase()] &&
      DIC[browserData.language.toLowerCase()][key.toLowerCase()]
    ) {
      return DIC[browserData.language.toLowerCase()][key.toLowerCase()];
    } else {
      console.error(
        "No translation for language " +
          browserData.language +
          " of key '" +
          key +
          "'"
      );
      return key;
    }
  }
}



// WEBPACK FOOTER //
// ./src-cookie-manager/init/locales.js